import { createStructuredSelector } from 'reselect';
import {
  ACQUISITION_LIST, ACQUISITION_LIST_SUCCESS, ACQUISITION_LIST_ERROR,
  ACQUISITION_PAGE_SET,
  ACQUISITION_DETAIL, ACQUISITION_DETAIL_SUCCESS, ACQUISITION_DETAIL_ERROR,
  ACQUISITION_ADD, ACQUISITION_ADD_SUCCESS, ACQUISITION_ADD_ERROR, ACQUISITION_ADD_CHANGE,
  ACQUISITION_FILTER_DETAIL_TYPE, ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS,
  ACQUISITION_FILTER_DETAIL_PARENT, ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS,
} from '../../actions';

export const NAME = 'acquisition';

export const AcquisitionList = (page, num_page, orderBy, filters) => ({ type: ACQUISITION_LIST, payload: { page, num_page, orderBy, filters } });
export const AcquisitionListSuccess = (data) => ({ type: ACQUISITION_LIST_SUCCESS, payload: data });
export const AcquisitionListError = (error) => ({ type: ACQUISITION_LIST_ERROR, payload: error });
export const AcquisitionPageSet = (data) => ({ type: ACQUISITION_PAGE_SET, payload: data });
export const AcquisitionDetail = (data) => ({ type: ACQUISITION_DETAIL, payload: data });
export const AcquisitionDetailSuccess = (data) => ({ type: ACQUISITION_DETAIL_SUCCESS, payload: data });
export const AcquisitionDetailError = (error) => ({ type: ACQUISITION_DETAIL_ERROR, payload: error });
export const AcquisitionAddChangeSet = (data) => ({ type: ACQUISITION_ADD_CHANGE, payload: data });
export const AcquisitionAdd = (data) => ({ type: ACQUISITION_ADD, payload: data });
export const AcquisitionAddSuccess = (message) => ({ type: ACQUISITION_ADD_SUCCESS, payload: message });
export const AcquisitionAddError = (error) => ({ type: ACQUISITION_ADD_ERROR, payload: error });
export const AcquisitionFilterDetailType = () => ({ type: ACQUISITION_FILTER_DETAIL_TYPE });
export const AcquisitionFilterDetailTypeSuccess = (data) => ({ type: ACQUISITION_FILTER_DETAIL_TYPE_SUCCESS, payload: data });
export const AcquisitionFilterDetailParent = () => ({ type: ACQUISITION_FILTER_DETAIL_PARENT });
export const AcquisitionFilterDetailParentSuccess = (data) => ({ type: ACQUISITION_FILTER_DETAIL_PARENT_SUCCESS, payload: data });

const acquisition = (state) => state[NAME];
export const AcquisitionSelector = createStructuredSelector({ acquisition });
